// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-card{border-radius:20px 20px 0 0!important;padding:8px}.main-card-link{color:inherit!important;text-decoration-color:var(--v-primary-base);text-decoration-thickness:3px}.main-card-link:hover{color:var(--v-primary-base)!important}.main-card-text{padding-left:12px;padding-right:12px;padding-bottom:8px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
